import { forwardRef } from 'react';

export type InputContainerVariant = 'default' | 'focused' | 'error';
export type InputContainerSize = 'medium' | 'large';

export interface InputContainerProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?: InputContainerVariant;
  size?: InputContainerSize;
  children: React.ReactNode;
}

const InputContainer = forwardRef<HTMLDivElement, InputContainerProps>(({
  variant = 'default',
  size = 'large',
  children,
  className = '',
  ...props
}, ref) => {
  const getContainerClasses = () => {
    const baseClasses = [
      'flex',
      'items-center',
      'justify-center',
      'self-stretch',
      'bg-fill-bg-default',
      'overflow-hidden',
      'transition-all',
      'duration-200'
    ];

    // Size classes
    const sizeClasses = {
      medium: ['min-h-12', 'rounded-[20px]'],
      large: ['min-h-16', 'rounded-[28px]']
    };

    // Variant classes
    const variantClasses = {
      default: ['shadow-chat-input'],
      focused: ['shadow-chat-input-focused'],
      error: ['shadow-chat-input-error', 'border', 'border-danger-border']
    };

    return [
      ...baseClasses,
      ...sizeClasses[size],
      ...variantClasses[variant],
      className
    ].filter(Boolean).join(' ');
  };

  return (
    <div
      ref={ref}
      className={getContainerClasses()}
      {...props}
    >
      {children}
    </div>
  );
});

InputContainer.displayName = 'InputContainer';

export default InputContainer;